export const SET_ADMIN = 'SET_ADMIN';
export const TOGGLE_COLLAPSING_MENU = 'TOGGLE_COLLAPSING_MENU';
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
export const SWITCH_LOCALE = 'SWITCH_LOCALE';
export const GET_SESSION = 'GET_SESSION';
export const LOAD_RESELLER = 'LOAD_RESELLER';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const EDIT_PROFILE_PHOTO = 'EDIT_PROFILE_PHOTO';
export const EDIT_RESELLER_PROFILE = 'EDIT_RESELLER_PROFILE';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const GET_USER_DATA = 'GET_USER_DATA';
export const USER_DATA_REFRESH = 'USER_DATA_REFRESH';
export const EDIT_RESELLER_PHOTO = 'EDIT_RESELLER_PHOTO';
export const EDIT_RESELLER_FAVICON = 'EDIT_RESELLER_FAVICON';
export const LOAD_PARTNERS_LAYOUT = 'LOAD_PARTNERS_LAYOUT';
export const LOAD_RESELLERS_LAYOUT = 'LOAD_RESELLERS_LAYOUT';
export const LOAD_IMPORTS = 'LOAD_IMPORTS';
export const LOAD_FAVORIS_ORDER = 'LOAD_FAVORIS_ORDER';
export const SET_OPERATOR_MACHINE = 'SET_OPERATOR_MACHINE';
export const SET_NAVIGATION_DATE = 'SET_NAVIGATION_DATE';
export const INIT_GLOBAL_SEARCH = 'INIT_GLOBAL_SEARCH';
export const SET_GLOBAL_SEARCH_SECTION_TAB = 'SET_GLOBAL_SEARCH_SECTION_TAB';
export const SET_GLOBAL_SEARCH_SECTION_COUNT = 'SET_GLOBAL_SEARCH_SECTION_COUNT';
export const SET_RESELLER_FOR_TRANSLATIONS = 'SET_RESELLER_FOR_TRANSLATIONS';
